var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { shapes, util } from '@joint/plus';
var AddButton = /** @class */ (function (_super) {
    __extends(AddButton, _super);
    function AddButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddButton.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'kanban.AddButton',
            attrs: {
                body: {
                    strokeWidth: 1,
                    stroke: '#DDDDDD',
                    rx: 4,
                    ry: 4
                },
                label: {
                    text: '+ Add Task',
                    fontSize: 14,
                    fontFamily: 'Helvetica'
                }
            },
            stackElementIndex: Number.MAX_SAFE_INTEGER / 2,
            z: -2
        }, _super.prototype.defaults);
    };
    AddButton.isAddButton = function (cell) {
        return cell.get('type') === 'kanban.AddButton';
    };
    return AddButton;
}(shapes.standard.Rectangle));
export { AddButton };
